import React, { useContext } from 'react';
import './activity-box.scss';
import TranslateService from '../../../services/translate-service';
import { eventStoreContext } from '../../../stores/events-store';
import { TinderItem } from '../../helpers/interfaces';
import { observer } from 'mobx-react';

interface ActivityBoxProps {
	activity: TinderItem;
	onClick: () => void;
}

const ActivityBox = ({ activity, onClick }: ActivityBoxProps) => {
	const {
		name,
		isVerified,
		category,
		images,
		videos,
		description,
		icon,
		destination,
		id,
		downloadedImages,
		downloadedVideos,
	} = activity;
	const eventStore = useContext(eventStoreContext);

	const errors = [];
	if (!category) {
		errors.push(TranslateService.translate(eventStore, 'MISSING_CATEGORY'));
	}
	if (!images?.length && !videos?.length) {
		errors.push(TranslateService.translate(eventStore, 'MISSING_IMAGES'));
	}
	if (name.indexOf('http') !== -1) {
		errors.push(TranslateService.translate(eventStore, 'MISSING_ACTIVITY_NAME'));
	}
	if (!description) {
		errors.push(TranslateService.translate(eventStore, 'MISSING_DESCRIPTION'));
	}

	const test: any = activity.location ?? {};
	if (!(test && test.latitude && test.longitude && test?.address)) {
		errors.push(TranslateService.translate(eventStore, 'MISSING_LOCATION'));
	}
	if (destination === 'N/A') {
		errors.push(TranslateService.translate(eventStore, 'MISSING_DESTINATION'));
	}

	// const mediaError =
	// 	activity.images.length != activity.downloadedImages?.length ||
	// 	activity.videos.length != activity.downloadedVideos?.length;
	const mediaError =
		(images.length > 0 && !downloadedImages?.length) || (videos.length > 0 && !downloadedVideos?.length);
	// if (images.length != downloadedImages?.length || videos.length != downloadedVideos?.length) {
	if (mediaError) {
		errors.push(TranslateService.translate(eventStore, 'MEDIA_NOT_DOWNLOADED'));
	}

	function renderErrors(errors: string[]) {
		return <div className="activity-box-errors">{errors.join(', ')}</div>;
	}

	const errorText =
		errors.length === 1
			? TranslateService.translate(eventStore, 'THERE_IS_ONE_PROBLEM')
			: TranslateService.translate(eventStore, 'THERE_ARE_X_ERRORS').replace('{X}', errors.length.toString());

	return (
		<div className="activity-box" onClick={onClick}>
			{icon}
			<div className="activity-box-name">{TranslateService.translate(eventStore, name)}</div>
			<div className="activity-box-status">
				{errors.length > 0 ? (
					<div className="activity-box-error" title={errors.join('\n')}>
						<span>{errorText}</span>
						{renderErrors(errors)}
					</div>
				) : (
					<div className="activity-box-all-good">{TranslateService.translate(eventStore, 'ALL_GOOD')}</div>
				)}
			</div>
			<div className="activity-box-is-verified">
				<img src={isVerified ? '/images/admin/verified.png' : '/images/admin/unverified.png'} />
				{TranslateService.translate(eventStore, isVerified ? 'VERIFIED' : 'UNVERIFIED')}
			</div>
		</div>
	);
};

export default observer(ActivityBox);
